import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import { useIntl } from 'react-intl'

import { GET_ALL_LIMIT } from '@/lib/core/constants/constants'
import { SelectField, SelectOption } from '@/lib/core/components/Select'

import { useOrganizationColleagues } from '@/lib/features/Account/api'
import { useMyContacts } from '@/lib/features/Contacts/api'
import messages from '@/lib/features/SmartShares/components/ShareAssetModal/ShareAssetModal.messages'
import { ShareFormState } from '@/lib/features/SmartShares/components'

import { Container } from './SelectContactFor.styles'

export type SelectContactToProp = {
  shareAssetValues?: ShareFormState
  defaultValue?: SelectOption
}

export const SelectContactTo = ({ shareAssetValues, defaultValue }: SelectContactToProp) => {
  const { formatMessage } = useIntl()
  const { formState } = useFormContext()

  const myContacts = useMyContacts({
    pageSize: GET_ALL_LIMIT,
  })

  const orgData = useOrganizationColleagues(
    shareAssetValues
      ? {
          pageSize: GET_ALL_LIMIT,
          organizationId: shareAssetValues.organizationTo,
        }
      : null,
  )

  const options = useMemo(
    () =>
      orgData.data?.results
        ?.filter((option) => option.user.shareContact)
        ?.sort((a, b) => {
          const aFullName = `${a.user.firstName} ${a.user.lastName}`.toLowerCase()
          const bFullName = `${b.user.firstName} ${b.user.lastName}`.toLowerCase()
          let res = aFullName.localeCompare(bFullName, 'en', { caseFirst: 'upper' })
          if (res === 0) {
            res = a.user.id - b.user.id
          }
          return res
        })
        ?.map(
          ({ user }) =>
            ({
              label: `${user.firstName} ${user.lastName}`,
              value: user.id,
            }) as SelectOption,
        ) ?? [],
    [orgData.data?.results],
  )

  const organization = useMemo(
    () =>
      myContacts.data.results.find(
        ({ organizationTo: { id } }) => id === Number(shareAssetValues?.organizationTo),
      ),
    [myContacts?.data?.results, shareAssetValues],
  )

  return (
    <Container>
      <SelectField
        aria-labelledby="contactTo"
        name="contactTo"
        label={`Select contact for ${organization?.organizationTo.name}`}
        placeholder={formatMessage(messages.organizationToPlaceholder)}
        disabled={formState.isSubmitting}
        required
        selectProps={{
          defaultValue,
          isDisabled: formState.isSubmitting,
          options,
        }}
      />
    </Container>
  )
}
